<div class="displayMiniPrompt">
    <button mat-raised-button color="warn" class="wrapper icon-button" (click)="installPwa()">
        <mat-icon>download</mat-icon>
    </button>
    <span class="hide-lt-md">
            <mat-label class="label pwaMessage">
                {{'general.pwaInstall3' | transloco}}
            </mat-label>
        </span>
    <span fxLayout="row" class="hide-gt-sm">
        <mat-label class="label pwaMessage">
            {{'general.pwaInstall4' | transloco}}
        </mat-label>
    </span>
</div>
<mat-checkbox [(ngModel)]="isChecked" style="padding-top: 5px" (change)="onChecked($event.checked)">{{'general.dontShow' | transloco}}</mat-checkbox>

<!--{{'general.pwaInstall2' | transloco}}-->

<!--<div *ngIf="data.mobileType === 'android' || data.mobileType === 'web'" color="primary" class="android-prompt">-->
<!--    <div>-->
<!--        <h1>install me</h1>-->
<!--    </div>-->
<!--    <button mat-button (click)="installPwa()">-->
<!--    </button>-->
<!--    <button (click)="close()">-->
<!--        close-->
<!--        &lt;!&ndash;        <mat-icon>close</mat-icon>&ndash;&gt;-->
<!--    </button>-->
<!--</div>-->

<!--<div *ngIf="data.mobileType !== 'web'" color="primary" class="android-prompt">-->
<!--    <div>-->
<!--        <h1>install me</h1>-->
<!--    </div>-->
<!--    <button mat-button (click)="installPwa()">-->
<!--    </button>-->
<!--    <button (click)="close()">-->
<!--        close-->
<!--    </button>-->
<!--</div>-->


<!--<div *ngIf="data.mobileType === 'ios'" class="ios-prompt">-->
<!--    <button class="close-ios-inv" mat-button color="primary" (click)="close()">-->
<!--    To install this web app on your device tap the Menu button and then 'Add to Home screen' button<-->
<!--    </button>-->
<!--</div>-->
